
  <div class="row py-3 booking-stepper mb-4">
    <div
         class="col-12 d-flex flex-column flex-sm-row justify-content-start justify-content-sm-between align-items-sm-center">

      <div class="d-flex flex-row align-items-center">
        <app-radial-progress class="me-3 d-flex"
                             [stepsCount]="stepsCount"
                             [currentStepIndex]="currentStepIndex + 1">
        </app-radial-progress>
        <div class="d-flex flex-column ">
          <span *ngIf="salonName"
                class="text-height-0 notranslate">{{ salonName }}</span>
          <ng-container *ngIf="currentStepIndex === 0">
            <h1 class="steps-title mb-1 h3 text-height-0 fw-bolder">
              <span [translate]="'BOOKING-PART.STEPS.VISIT-SLOTS.STEP-TITLE'"></span>
            </h1>
            <span class="text-dark">

              <span [translate]="'BOOKING-PART.STEPPER.NEXT-STEP'"></span>
              <span [translate]="'BOOKING-PART.STEPS.CUSTOMER-DATA.STEP-TITLE'"></span>
            </span>
          </ng-container>
          <ng-container *ngIf="currentStepIndex === 1">
            <h1 class="steps-title mb-1 h3 text-height-0 fw-bolder">
              <span [translate]="'BOOKING-PART.STEPS.CUSTOMER-DATA.STEP-TITLE'"></span>
            </h1>
          </ng-container>
        </div>
      </div>

    </div>
  </div>

